import { HelpCircle } from 'lucide-react'
import { openHelpDrawer } from '../lib/help'

interface HelpLinkProps {
  section: string
  children?: React.ReactNode
}

export function HelpLink({ section, children }: HelpLinkProps) {
  return (
    <button
      onClick={() => openHelpDrawer(section)}
      className="inline-flex items-center gap-1 text-sm text-primary hover:underline"
    >
      <HelpCircle className="w-3.5 h-3.5" />
      {children || 'View help guide'}
    </button>
  )
}
